import { PaperDetailInsert, PaperDetailDelete, PaperDetailUpdate, PaperDetailGetById, PaperDetailGetList, PaperDetailGetPageList } from "@/api/paperdetail/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    PaperDetailInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            PaperDetailInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    PaperDetailUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            PaperDetailUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    PaperDetailGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            PaperDetailGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    PaperDetailGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            PaperDetailGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    PaperDetailGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            PaperDetailGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}